/** This function gives you the display color of a peer review score, even if the score isn't an integer (i.e. it's an average). */
export function peerReviewScoreColor(
  numericalScore: number | undefined
): string {
  if (numericalScore === 0 || numericalScore === undefined) {
    // Represents N/A, included here for convenience
    return 'bg-on-surface-disabled text-on-surface-var'
  } else if (numericalScore >= 2.5) {
    return 'bg-core-success text-core-on-success'
  } else if (numericalScore >= 1.5) {
    return 'bg-fixed-accent-color text-core-on-secondary'
  } else {
    return 'bg-core-error text-core-on-error'
  }
}
